import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { withStyles } from 'src/app/helpers/styles';

interface MyProps {
  largeThumbnail?: string;
  className?: string;
}

@withStyles({
  base: [require('./CommunityHeader.base.scss')],
  desktop: [require('./CommunityHeader.desktop.scss')]
})
export class CommunityHeader extends React.Component<MyProps> {
  render(): JSX.Element {
    return (
      <div className="bg-black">
        {/* Mobile Style */}
        <div className="fld-column d-flex d@md-none pt-16">
          {this.renderedInfo}
          <div className="flex-noshrink community-header__thumbnail mt-30 position-relative w-100 bg-black-dark">
            {this.renderedMobileThumbnail}
          </div>
        </div>
        {/* Desktop Style */}
        <div className={classnames('d-none d@md-flex fld-row flw-nowrap jc-between ai-stretch community-header', this.props.className)}>
          <div className="d-flex fld-column jc-center">
            {this.renderedInfo}
          </div>
          <div className="flex-noshrink community-header__thumbnail position-relative w-100">
            {this.renderedDesktopThumbnail}
          </div>
        </div>
      </div>
    );
  }

  private get renderedMobileThumbnail(): JSX.Element {
    const { largeThumbnail } = this.props;
    return <img alt="thumbnail" className="w-100" src={largeThumbnail} />;
  }

  private get renderedDesktopThumbnail(): JSX.Element {
    const { largeThumbnail } = this.props;
    const thumbnailClass = 'fld-column jc-center ai-center w-100 h-100';

    return <img alt="thumbnail" className={thumbnailClass} src={largeThumbnail} />;
  }

  private get renderedInfo(): JSX.Element {
    return (
      <FormattedMessage id="community.header">
        {(message) => <div className="flex-noshrink fs-16 fs@md-50 fw-500 lh-1-26 w-100 px-16 px@md-0 tt-uppercase community-header__container-info">{message}</div>}
      </FormattedMessage>
    );
  }
}
